import { render } from "./createUserModal.vue?vue&type=template&id=31109d4d&scoped=true"
import script from "./createUserModal.vue?vue&type=script&lang=js"
export * from "./createUserModal.vue?vue&type=script&lang=js"

import "./createUserModal.vue?vue&type=style&index=0&id=31109d4d&lang=scss&scoped=true"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31109d4d"]])

export default __exports__